import { Button, Modal } from 'antd';
import { t } from 'i18next';
import Iconnopermission from '../../../assets/Images/icons/icon-nopermission';

const ErrorNoPer = ({
    open,
    text = 'Please contact administrator owner@Whitefact.com',
    handelClose,
}) => {
    return (
        <Modal
            width={600}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6">
                <Iconnopermission />
                <div className="text-2xl font-semibold">
                    {t('You dont have permission to access')}
                </div>
                <div>{text}</div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button onClick={handelClose} size="large" type="primary">
                    {t('common.Close')}
                </Button>
            </div>
        </Modal>
    );
};
export default ErrorNoPer;
